<template>
  <VRow justify="center">
    <VCol cols="12" md="8">
      <VCard class="ma-2 mt-md-10 py-12 text-center d-flex flex-column justify-center align-center">
        <img src="../assets/img/404.svg" width="40" class="mb-6 mt-12">
        <span class="headline mb-10">
          {{ $t('404') }}<br>
          {{ $t('pageNotFound') }}
        </span>
        <RouterLink to="/" class="mb-6 body-2 text-decoration-none">
          {{ $t('toMainPage') }}
        </RouterLink>
        <a :href="`mailto:${SUPPORT_EMAIL}`" class="body-2 text-decoration-none mb-12">
          {{ $t('contactUs') }}
        </a>
      </VCard>
    </VCol>
  </VRow>
</template>

<script>
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'Error404',
  data() {
    return {
      SUPPORT_EMAIL,
    };
  },
  metaInfo() {
    return {
      title: this.$t('pageNotFound'),
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  404: 404 error
  pageNotFound: Page not found
  toMainPage: Go to the main page
  companyInfo: Company information
  contactUs: Contact us
</i18n>

<i18n locale="ru" lang="yaml">
  404: 404 ошибка.
  pageNotFound: Нет такой страницы
  toMainPage: На главную страницу
  companyInfo: Информация о компании
  contactUs: Написать нам письмо
</i18n>
